var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            staticClass: "margin-bottom",
            attrs: { label: "Observações: ", addMarginTop: false }
          }),
          _c(
            "el-row",
            { staticClass: "margin-left" },
            [
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- Cálculos efetuados com base no disposto na Lei N° 1.351 de 14 de Novembro de 2019"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- O pagamento da terra poderá ser efetuado à vista ou parcelado em prestações anuais"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- As parcelas serão atualizadas monetariamente pela variação do Índice de Preços ao Consumidor Amplo Especial (IPCA-E), que é reajustado no dia 01 de abril de cada ano"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- O valor do Índice de Preços ao Consumidor Amplo (IPCA-E) vigente na data atual, e considerado para a correção das parcelas é de 1.7"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- Do valor do imóvel, após as deduções previstas nos artigos seguintes, será concedido desconto de 50% (cinquenta por cento) para pagamento à vista"
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-330dbd36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330dbd36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/ObservacoesRR.vue
// module id = null
// module chunks = 